import type { BranchKey, WorkspaceKey } from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import { CircularSpinner } from '@festina-life/ui/feedback'
import { withSuspense } from '@festina-life/ui/libs'

import { useConciseBranch } from '../../uiModels/branches/useConciseBranch'
import { OperationsProvider } from '../../workspace/OperationsProvider'
import { ConfigurationBranchStatus } from '../branchNameWithStatus/ConfigurationBranchStatus'
import { DetailsPanel } from '../detailsPanel/DetailsPanel'
import { UnifiedBranchWorkspaceDetailsTabs } from './branchDetails/UnifiedBranchWorkspaceDetailsTabs'
import { BranchLoadingStatusAndOperationCount } from './branchesTree/BranchLoadingStatusAndOperationCount'

type Props = {
  workspaceKey: Optional<WorkspaceKey>
  branchKey: BranchKey
  onClose: () => void
}

const UnifiedBranchWorkspaceDetailsPanelInternal = ({
  workspaceKey,
  branchKey: branchKeyProp,
  onClose,
}: Props) => {
  const branchKey = workspaceKey?.branchKey ?? branchKeyProp
  const conciseBranch = useConciseBranch({
    branchName: branchKey.name,
    server: branchKey.server,
    shouldFallbackToStandard: false,
  })

  return conciseBranch ? (
    <OperationsProvider
      branchKey={branchKey}
      isDisabledChangesetsRelevant={false}
      workspaceKey={workspaceKey}
    >
      <DetailsPanel
        onClose={onClose}
        header={
          <>
            <span className="text-gray-500 dark:text-gray-400">
              {branchKey.server}
            </span>
            <ConfigurationBranchStatus branchKey={branchKey} />
          </>
        }
        status={<BranchLoadingStatusAndOperationCount branchKey={branchKey} />}
      >
        <UnifiedBranchWorkspaceDetailsTabs branchKey={branchKey} />
      </DetailsPanel>
    </OperationsProvider>
  ) : null
}

export const UnifiedBranchWorkspaceDetailsPanel = withSuspense(
  UnifiedBranchWorkspaceDetailsPanelInternal,
  { fallback: <CircularSpinner className="mx-auto my-2 size-8" /> },
)
